import React from "react"
import InfograficaPage9 from '../../components/Capitolo2/InfograficaPage9'

const Page9 = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div className='h-100' ref={innerRef} style={{ display: "flex", flexDirection: "column", height: "100%",  background: backgroundColor, color: color }}>
      <div className="grid-cols-12 xl:grid-cols-12">
        <div className='col-1'>
        </div>
        <div className='col-5'>
          <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
            Eppure l’elettrico in Italia resta ancora una frontiera in via di esplorazione:
            sebbene in crescita, nelle flotte aziendali solo l’1.5
            per cento delle auto presenta, nel 2019, l’alimentazione elettrica.
          </div>
        </div>
        <div className='col-6'>
          <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
            I motivi della scarsa propensione dei fleet manager a passare
            a un veicolo elettrico sono diversi, ma Edison – per superare queste stesse barriere –
            ha lanciato il servizio Fleet Audit.
          </div>
        </div>
        <div className='col-1'>

        </div>
      </div>
      <div className="grid-cols-12 xl:grid-cols-12" style={{ flexGrow: 1, alignItems: "stretch" }}>
        <div className="col-1" />
        <div className='col-11' style={{ display: "flex", flexDirection: "column", maxHeight: "100%" }}>
          <div className='lg:mt-3 xl:mt-2' style={{minHeight: 24}}>
            <div className='font-family-acumin lg:font-18 xl:font-16'>Le paure nei confronti dell’elettrico</div>
          </div>
          <div className='pt-3' style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            <InfograficaPage9 openPercent={openPercent} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page9
